/**
 * What to show the user for a password-reset response that is not a success.
 *
 * Since NEW-26 the API answers a mistyped or expired code with a 400 carrying a message worth
 * reading ("That verification code is not correct…", "…has expired. Request a new one…"), so the
 * response body is always the first choice. Before that, every failure — a wrong code included —
 * came back as a 500 saying "An unexpected error occurred", and the screens had nothing better to
 * show than "Failed to reset password".
 *
 * The fallbacks exist for the one response that has no body at all: the BARE 429 returned by the
 * per-IP rate limiter and by the per-account throttle (NEW-19). That one is deliberately empty —
 * status only, no message, no Retry-After — so that being throttled for hammering ONE account
 * cannot be told apart from being throttled for hammering from one address. Nothing can put a
 * message in it, so the client supplies the wording; otherwise the user is shown axios's own
 * "Request failed with status code 429".
 */
export function authErrorMessage(
  status: number,
  data: unknown,
  fallback: string,
): string {
  const message = (data as { message?: unknown } | null | undefined)?.message;
  if (typeof message === "string" && message.trim()) return message;

  if (status === 429) {
    return "Too many attempts. Please wait a few minutes and try again.";
  }

  return fallback;
}
